import type { HTMLAttributes } from 'react';
import { Spinner } from './Spinner';
import styles from './PageLoader.module.css';

interface PageLoaderProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  fullscreen?: boolean;
}

export function PageLoader({ label = 'Cargando...', fullscreen = false, className = '', ...props }: PageLoaderProps) {
  const classes = [
    styles['page-loader'],
    fullscreen ? styles['page-loader--fullscreen'] : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div {...props} className={classes} role="status" aria-live="polite" aria-busy="true">
      <Spinner />
      <span className={styles['page-loader__label']}>{label}</span>
    </div>
  );
}
